import { generateGuid } from "../../shared/services/utils";

export const updateRecentFiles = ({ fileName, songNumber }) => {
  if (typeof fileName !== 'string' || !/\.txt$/i.test(fileName)) return;
  try {
    let recentFiles = JSON.parse(localStorage.getItem("recentFiles")) || [];
    const dateTime = new Date().toISOString();
    recentFiles = recentFiles.filter((f) => f.fileName !== fileName);
    recentFiles.unshift({ fileName, songNumber, dateTime });
    localStorage.setItem("recentFiles", JSON.stringify(recentFiles));
  } catch (e) {
    console.error("Failed to update recent files:", e);
  }
};

export const getRecentFiles = () => {
  try {
    return JSON.parse(localStorage.getItem("recentFiles")) || [];
  } catch (e) {
    console.error("Failed to get recent files:", e);
    return [];
  }
};

export const clearRecentFiles = () => {
  localStorage.removeItem('recentFiles');
};

export const updateDeviceInfo = (d) => {
  try {
    localStorage.setItem("deviceInfo", JSON.stringify(d));
  } catch (e) {
    console.error("Failed to update device info:", e);
  }
};

export const getDeviceInfo = () => {
  try {
    let parse = JSON.parse(localStorage.getItem("deviceInfo"));
    if (!parse) {
      parse = { guid: generateGuid(), name: null };
      localStorage.setItem("deviceInfo", JSON.stringify(parse));
    }
    if (parse.guid === undefined) parse.guid = generateGuid();
    return parse;
  } catch (e) {
    console.error("Failed to get device info:", e);
    return { guid: generateGuid(), name: null };
  }
};

export const updateConnectionInfo = (i) => {
  try {
    localStorage.setItem("connectionInfo", JSON.stringify(i));
  } catch (e) {
    console.error("Failed to update connection info:", e);
  }
};

export const getConnectionInfo = () => {
  try {
    return JSON.parse(localStorage.getItem("connectionInfo")) || {};
  } catch (e) {
    console.error("Failed to get connection info:", e);
    return {};
  }
};
